import {getUUID, isnull, localClear, localGetBoolean, localSave, Toast, ToastTime, ToastType} from "./tools";
import {doLoginAsVisitor, doPay, reloginInBg} from "../api/home-api";
import Tips from "./Tips";
import router from '../router'
import StatisticsHelper from "./StatisticsUtils";
import EventBusConstant from "../push/const/EventBusConstant";
import TipsUtils from "./TipsUtils";
export default class AppHelper {
  static bindEvent(appInstance){
    let curObj = appInstance
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.LOADING_SHOW, (msg, accId) => {
      if (isnull(curObj.loadingObj)) {
        if (isnull(msg)) {
          msg = ''
        }
        curObj.loadingObj = curObj.$vs.loading({
          type: 'circles',
          text: msg
        })
      }
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.RE_LOGIN, (successCallback, failCallback) => {
      if (!localGetBoolean(global.LOGIN_STATUS, false)) {
        if (isnull(curObj.$globalAppCfg.deviceUUID)) {
          getUUID(curObj).then(() => {
            curObj.judgeAccount(successCallback, failCallback)
          })
        } else {
          curObj.judgeAccount(successCallback, failCallback)
        }
      } else
        reloginInBg(successCallback, function (code, msg, page) {
          if (code == -10) {

            if (curObj.$root.$sseClient) {
              curObj.$root.$sseClient.disconnect()
            }
            curObj.$globalAppCfg.sseSource = null
            curObj.$globalAppCfg.setUser({})
            curObj.$globalAppCfg.setSession('')
            curObj.$globalAppCfg.setGlobalParams({})
            localClear()
            router.togo('/')
            Toast.info(Tips.relogin_failed, curObj)
          }
          failCallback && failCallback(code, msg, page)
        }, appInstance)
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.EXIT_2_WELCOME, (successCallback) => {
      if (curObj.$root.sseClient) {
        curObj.$root.sseClient.disconnect()
        curObj.$root.sseClient = null
      }
      curObj.$globalAppCfg.sseSource = null
      curObj.$globalAppCfg.setUser({})
      curObj.$globalAppCfg.setSession('')
      curObj.$globalAppCfg.setGlobalParams({})
      curObj.leaveRTM()
      localClear()
      router.togo('/')
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.LOADING_HIDE, (msg, type) => {
      if (!isnull(curObj.loadingObj)) {
        curObj.loadingObj.close()
        curObj.loadingObj = ''
      }
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.OPEN_IN_APP, (msg, type) => {
      StatisticsHelper.user_action()
      window.open("https://chutney.onelink.me/gO7z/4029f9f5", '_blank')
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.SHOW_DEVICE_ERROR, () => {
      curObj.showDeviceErrorDialog()
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.TOAST, (msg, type, time) => {
      if (isnull(msg)) {
        return
      }
      let color = 'primary'
      switch (type) {
        case ToastType.TOAST_INFO:
          color = 'success'
          break
        case ToastType.TOAST_DEBUG:
          color = 'primary'
          break
        case ToastType.TOAST_WARN:
          color = 'warning'
          break
        case ToastType.TOAST_ERROR:
          color = 'danger'
          break
      }
      if (!isnull(msg)) {
        curObj.msgList.push({
          uid: new Date().getTime(),
          msg: msg,
          time: isnull(time) ? ToastTime.SHORT : time,
        })
      }
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.LC_NEW_MSG, (msg, time) => {
      if (isnull(msg)) {
        return
      }
      if (!isnull(msg)) {
        curObj.lcMsgList.push({
          uid: new Date().getTime(),
          lcMsg: msg,
          time: isnull(time) ? ToastTime.LONG : time,
        })
      }
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.KICKED_OFF, () => {
      Toast.info(Tips.after_kicked_out, curObj)
      if (curObj.$root.$sseClient) {
        curObj.$root.$sseClient.disconnect()
      }
      curObj.$globalAppCfg.sseSource = null
      curObj.$globalAppCfg.setUser({})
      curObj.$globalAppCfg.setSession('')
      curObj.$globalAppCfg.setGlobalParams({})
      curObj.leaveRTM()
      localClear()
      router.togo('/')
      curObj.$refs.rc.cancelRequest(1)
      curObj.showMsgAction(1, ['Ok'], [function (extra) {
        curObj.hideMsgActionDialog()
      }], {}, true)
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.SHOW_MSG_ACTION_DIALOG, (type, actions, callbacks = null, extra = {}, hideFromOut = true, msg = null) => {
      curObj.showMsgAction(type, actions, callbacks, extra, hideFromOut, msg)
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.HIDE_MSG_ACTION_DIALOG, () => {
      curObj.hideMsgActionDialog()
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.SHOW_ALERT_ACTION_DIALOG, (type, actions, callbacks = null, extra = {}, hideFromOut = true, msg = null, title = null) => {
      curObj.showAlertActionDialog(type, actions, callbacks, extra, hideFromOut, title, msg)
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.HIDE_ALERT_ACTION_DIALOG, () => {
      curObj.hideAlertActionDialog()
    })
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.pay_res_event_success, (svip, diamond, accId) => {
      curObj.showRechargeSucDialog(diamond, svip)
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_DO_REQUEST_CALL, (anchorId, successCallback, failCallback) => {
      curObj.$refs.rc.requestCall(anchorId, successCallback, failCallback)
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_DO_STOP_CALL, () => {
      curObj.$refs.rc.doStopCall()
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_RECHARGE_DIALOG, () => {
      curObj.showRecharge = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_RECHARGE_PAY, (pay, product) => {
      doPay(pay.payUrlSuffix, product.priceUSD, product.productId, function (data) {
        localSave('inPay', true)
        location.href = data
      }, function (code, msg, page) {
        Toast.error(TipsUtils.getErrorTips(code), page)
      }, curObj)
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_REPORT_BLOCK, (acc, type, room, callback) => {
      if (!isnull(acc)) {
        curObj.report.acc = acc
        curObj.report.type = type
        curObj.report.room = room
        curObj.report.show = true
        curObj.report.callback = callback
      }
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_HC, (type, url, rate = 1) => {
      console.log('type:' + type + ' ' + url)
      if (isnull(type) || isnull(url))
        return
      curObj.htmlPage.type = type
      curObj.htmlPage.url = url
      curObj.htmlPage.whRate = rate
      curObj.htmlPage.show = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_HIDE_HC, () => {
      if (curObj.htmlPage.type != 3)
        curObj.htmlPage.show = false
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_AUTO_PLAY, () => {
      curObj.showAutoPlayGuide = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_HIDE_HOLDER_IN_HOME, () => {
      curObj.showPreLoader = false
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_VCR_GUIDE, (boss, anchor) => {
      console.log('vcrguide:' + anchor + ' ' + boss)
      appInstance.vcrGuide.bossBtm = boss
      appInstance.vcrGuide.anchorBtm = anchor
      appInstance.vcrGuide.showed = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_HIDE_VCR_GUIDE, (boss, anchor) => {
      appInstance.vcrGuide.showed = false
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_PHOTO_GALLERY, (imgList, startIndex, from) => {
      appInstance.photos.imgList = imgList
      appInstance.photos.startViewIndex = startIndex
      appInstance.photos.from = from
      appInstance.photos.bigImgShow = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_MOMENT_SAYHI, (accountId, doAfterSucceedCallback, doAfterFailedCallback) => {
      if (!isnull(accountId)) {
        appInstance.greet.accountId = accountId;
        appInstance.greet.show = true
        appInstance.greet.callback = doAfterSucceedCallback
        appInstance.greet.failCallback = doAfterFailedCallback
      }
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_VIDEO, (src, poster) => {
      appInstance.showVideo(src, poster)
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_HIDE_VIDEO, () => {
      appInstance.hideVideo()
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_MOMENT_REPORT_DEL, (type, id, sucCallback) => {
      appInstance.momReport.type = type
      appInstance.momReport.id = id
      appInstance.momReport.sucCallback = sucCallback
      appInstance.momReport.show = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_VALIDATE_PROCESS, (successCallback, failCallback) => {
      if (curObj.inLogin)
        return;
      curObj.inLogin = true;
      if (curObj.fromAd) {
        doLoginAsVisitor(function (data, page) {
          curObj.inLogin = false;
          successCallback && successCallback(data, page)
        }, function (code, msg, page) {
          curObj.inLogin = false;
          failCallback && failCallback(code, msg, page)
        }, curObj)
        return;
      }
      if (curObj.vk.needValidate)
        return
      curObj.vk.sucCallback = successCallback
      curObj.vk.failedCallback = failCallback
      curObj.vk.needValidate = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_HIDE_VALIDATE_PROCESS, () => {
      curObj.vk.needValidate = false
      curObj.inLogin = false;
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_GAME_DIALOG, (gameList, from) => {
      if (curObj.game.show)
        return
      curObj.game.gameList = gameList
      if (isnull(gameList))
        return;
      curObj.game.from = from
      curObj.game.show = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_ROOM_TOOL_DIALOG, (...args) => {
      curObj.roomTool.type = args[0]
      if (curObj.roomTool.type == 2) {
        //mb
        curObj.roomTool.selfBoss = args[1]
        curObj.roomTool.micOff = args[2]
        curObj.roomTool.cameraOff = args[3]
        curObj.roomTool.rechargeCallback = args[4]
        curObj.roomTool.micCallback = args[5]
        curObj.roomTool.cameraCallback = args[6]
        curObj.roomTool.flipCallback = args[7]
      } else {
        //live,pc
        curObj.roomTool.pureOff = args[1]
        curObj.roomTool.rechargeCallback = args[2]
        curObj.roomTool.clearCallback = args[3]
      }
      curObj.roomTool.show = true
    })
    appInstance.$EventBus.$on(EventBusConstant.EVENT_SHOW_CALL_END, (needComment, roomId, anchorName, avatar) => {
      curObj.callEnd.type = needComment ? 1 : 2;
      curObj.callEnd.roomId = roomId;
      curObj.callEnd.name = anchorName;
      curObj.callEnd.avatar = avatar;
      curObj.callEnd.show = true;
    })
  }
  static unbindEvent(appInstance){
    appInstance.$EventBus.$off(EventBusConstant.EVENT_SHOW_ROOM_TOOL_DIALOG)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_SHOW_GAME_DIALOG)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_HIDE_VALIDATE_PROCESS)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_SHOW_VALIDATE_PROCESS)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_MOMENT_REPORT_DEL)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_SHOW_MOMENT_SAYHI)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_SHOW_PHOTO_GALLERY)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_SHOW_VCR_GUIDE)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_HIDE_VCR_GUIDE)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_HIDE_HOLDER_IN_HOME)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_AUTO_PLAY)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_HIDE_HC)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_SHOW_HC)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_REPORT_BLOCK)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_DO_REQUEST_CALL)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_DO_STOP_CALL)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_SHOW_RECHARGE_DIALOG)
    appInstance.$EventBus.$off(EventBusConstant.EVENT_RECHARGE_PAY)
    appInstance.$EventBus.$off(global.OPEN_IN_APP)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.KICKED_OFF)
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.SHOW_MSG_ACTION_DIALOG)
    appInstance.$EventBus.$on(appInstance.$globalAppCfg.HIDE_MSG_ACTION_DIALOG)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.LOADING_SHOW)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.LOADING_HIDE)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.TOAST)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.LC_NEW_MSG)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.RE_LOGIN)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.pay_res_event_success)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.EXIT_2_WELCOME)
    appInstance.$EventBus.$off(appInstance.$globalAppCfg.SHOW_DEVICE_ERROR)
  }
}



// WEBPACK FOOTER //
// ./src/utils/AppHelper.js